function storageFactory() {
  let inMemoryStorage = {};

  function isSupported() {
    try {
      const key = 'storage_test_dxxx888';
      localStorage.setItem(key, key);
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  function getItem(key) {
    if (isSupported()) {
      return localStorage.getItem(key);
    }
    return inMemoryStorage[key] || null;
  }

  function setItem(key, value) {
    if (key === 'lt_sessionKey' && window.ltPhoenix) {
      window.ltPhoenix.sessionKey = value;
    }
    if (isSupported()) {
      localStorage.setItem(key, value);
    } else {
      inMemoryStorage[key] = value;
    }
  }

  function removeItem(key) {
    if (isSupported()) {
      localStorage.removeItem(key);
    } else {
      delete inMemoryStorage[key];
    }
  }

  function clear() {
    if (isSupported()) {
      localStorage.clear();
    } else {
      inMemoryStorage = {};
    }
  }

  function key(n) {
    if (isSupported()) {
      return localStorage.key(n);
    } else {
      return Object.keys(inMemoryStorage)[n] || null;
    }
  }

  return {
    getItem,
    setItem,
    removeItem,
    clear,
    key,
  };
}

export default storageFactory;
